webpackJsonp([245976020538739],{

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Migrate your test data'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You can move existing test data into your new team.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Collaborators have the option to move tests into the team account. Head back to your personal account workspace by finding it in the main menu and clicking on it.  It will be your email:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528949833/teams/personal-workspace.png', style: { "max-width": "200px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To move entire test folders, find the "move" icon next to it, and follow the prompts.  This will copy all tests and any dependent components from within those tests.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528949408/teams/copy-to-org.png', style: { "max-width": "400px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528949406/teams/select-copy-to-org.png', style: { "max-width": "400px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To move individual tests, you can use the quick dropdown.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Just remember, that they won\'t copy components that compose the test:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528950009/teams/copy-move-indiv.png', style: { "max-width": "200px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finally, moving environments is quite easy as well:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528950333/teams/copy-move-env.png', style: { "max-width": "400px" } })
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-migrate-js-5e9b327ed952ffa93360.js